import {
  AdminCreditManagement,
  UserCreditManagement,
} from 'pages/credits/components';

import { Unauthorized } from 'components/unauthorized';
import { TokenExpired } from 'components/tokenExpired';
import { useCanAccess } from 'hooks/useCanAccess';

export const CreditManagementRoute = () => {
  const { canAccess, isAdmin, isExpired } = useCanAccess('credits');

  return isExpired ? (
    <TokenExpired />
  ) : isAdmin ? (
    <AdminCreditManagement />
  ) : canAccess ? (
    <UserCreditManagement />
  ) : (
    <Unauthorized />
  );
};
